"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = {
            image: null,
            attrs: {},
            loading: false
        };
    },
    onInput: function ({src, ...attrs}) {
        this.state.attrs = attrs;
        if (!src)
            return;
        if (window.BlobCache && window.BlobCache.hasOwnProperty(src))
            this.state.image = window.BlobCache[src];
        else {
            this.state.image = null;
            this.state.loading = true;
            window.fetch(corsProxy(src.replace(/^@/, '/@'))).then(response => response.blob()).then(blob => {
                this.state.loading = false;
                if (!blob || !/image\/(.{3,4})|application\/octet-stream/.test(blob.type))
                    return;
                this.state.image = URL.createObjectURL(blob);
                if (!window.BlobCache)
                    window.BlobCache = {};
                window.BlobCache[src] = this.state.image;
            }).catch(error => {
                console.log('Failed: ' + error);
                this.state.loading = false;
            });
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Image/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_attrs = require("marko/dist/runtime/vdom/helpers/attrs"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_attrs0 = {
        "class": "w-100 text-center"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (state.image) {
    out.e("img", marko_assign({}, marko_attrs(state.attrs), {
        src: state.image,
        draggable: "false"
      }), "0", component, 0, 4, {
        onclick: __component.d("click", () => component.emit('click'), false)
      });
  } else {
    out.e("div", {
        "class": marko_classValue(marko_classValue([
          "image-placeholder d-inline-flex align-items-center justify-content-center",
          (((input.class + " ") + (state.loading ? "animated-placeholder" : "")) + " ") + (!input.noBackground ? "theme-bg-fade" : "")
        ])),
        style: marko_styleValue(state.attrs.defaultStyle || state.attrs.style)
      }, "1", component, 1, 1, {
        onclick: __component.d("click", () => component.emit('click'), false)
      })
      .e("div", marko_attrs0, "2", component, 1)
        .e("i", {
            "class": marko_classValue(marko_classValue([
              "blue-grey-text text-lighten-3",
              input.icon || "bx bxs-landscape"
            ])),
            style: "font-size:250%"
          }, "3", component, 0, 1);
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
